export const showJobField = (fields,field_code) => {
    let field = fields?.filter((item)=> item?.field_code === field_code)[0]
    return field?.show
}